export default {
    title: "Zahlungsläufe erstellen",
    generatePaymentRuns: "Erstellen",
    generatePreview: "Vorschau",
    bankAccount: "Bankverbindung",
    costCenter: "Kostenstelle",
    customAmount: "Festen Betrag angeben",
    percentage: "Prozentsatz",
    roundDownToTens: "Auf Zehner runden",
    fixedAmount: "Fester Betrag",
    intendedUse: "Verwendungszweck",
    intendedUsePlaceholders: "Sie können im Verwendungszweck mehrere Platzhalter verwenden.",
    asPreview: "Nur Vorschau PDF erzeugen",
    comment: "Interner Kommentar",
    paymentRunsGenerated: "Zahlungsläufe wurden erstellt.",
    noValidPaymentRuns: "Die aktuelle Auswahl erzeugt keine gültigen Zahlungsläufe!",
    noBankAccountsToUse: "Es sind keine Bankkonten für die Zahlungsläufe verfügbar.",
    noCostCentersToUse: "Es sind keine Kostenstellen beim Vebrand hinterlegt",
    generatedRunsTitle: "Es entstehen folgende Zahlungsläufe",
    fromPayments: "keine Maßnahme | Eine Maßnahme | {count} Maßnahmen",
    noOpenPaymentProcesses: "Es wurden Maßnahmen gefunden, die keine offenen Zahlungen enthalten.",
    missingBankAccountProcesses: "Es wurden Maßnahmen gefunden, bei denen keine Bankdaten hinterlegt sind.",
    missingCreditorNumberProcesses: "Es wurden Maßnahmen gefunden, bei deren Organisation keine P5 Kreditorennummer hinterlegt ist.",
    errorOnCreation: "Es ist ein Fehler beim Erstellen der Zahlungsläufe aufgetreten.",
    noPaymentRunsCreated: "Es konnten keine Zahlungsläufe erstellt werden."
}